import { render, staticRenderFns } from "./PriceVariation.vue?vue&type=template&id=2857d61a"
import script from "./PriceVariation.vue?vue&type=script&lang=js"
export * from "./PriceVariation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports